import { render, staticRenderFns } from "./humanResource.vue?vue&type=template&id=06f0dd7d&lang=html&"
import script from "./humanResource.vue?vue&type=script&lang=js&"
export * from "./humanResource.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/service.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "humanResource.vue"
export default component.exports